import { logout } from '@trinity/utils'

export function loader() {
  return logout('/login')
}
